var _excluded = ["className", "onAfterClose", "onAfterOpen", "overlayClassName"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* istanbul ignore file */

/*
This is a compatability layer for Safari 14+.
Due to the way react-modal is rendered in safari the initial css classes are not used and the css animations are redundant.
This component adds the animation css classes using a timeout to force both states to be rendered.
*/

import React, { useCallback, useMemo, useState } from 'react';
import ReactModal from 'react-modal';
export var SafariCompatModal = function SafariCompatModal(_ref) {
  var className = _ref.className,
    onAfterClose = _ref.onAfterClose,
    onAfterOpen = _ref.onAfterOpen,
    overlayClassName = _ref.overlayClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var setIsOpenWithTimeout = function setIsOpenWithTimeout(state) {
    setTimeout(function () {
      setIsOpen(state);
    }, 0);
  };
  var onAfterCloseHandler = useCallback(function () {
    if (onAfterClose) {
      onAfterClose();
    }
    setIsOpenWithTimeout(false);
  }, [onAfterClose]);
  var onAfterOpenHandler = useCallback(function () {
    if (onAfterOpen) {
      onAfterOpen();
    }
    setIsOpenWithTimeout(true);
  }, [onAfterOpen]);
  var overlayClasses = useMemo(function () {
    return typeof overlayClassName !== 'string' && overlayClassName !== null && overlayClassName !== void 0 && overlayClassName.afterOpen ? {
      base: overlayClassName.base,
      afterOpen: isOpen ? overlayClassName.afterOpen : '',
      beforeClose: overlayClassName.beforeClose
    } : overlayClassName;
  }, [isOpen, overlayClassName]);
  var contentClasses = useMemo(function () {
    return typeof className !== 'string' && className !== null && className !== void 0 && className.afterOpen ? {
      base: className.base,
      afterOpen: isOpen ? className.afterOpen : '',
      beforeClose: className.beforeClose
    } : className;
  }, [className, isOpen]);
  return /*#__PURE__*/React.createElement(ReactModal, _extends({}, props, {
    className: contentClasses,
    onAfterClose: onAfterCloseHandler,
    onAfterOpen: onAfterOpenHandler,
    overlayClassName: overlayClasses
  }), props.children);
};